import { PayloadAction } from '@reduxjs/toolkit';
import { ArticleState, Filter, FilterOption } from '@/store/articles/state';

export const articlesReducer = {
  setFilters(state: ArticleState, { payload }: PayloadAction<Array<Filter>>) {
    state.filters = payload;
  },
  setAppliedFilters(state: ArticleState, { payload }: PayloadAction<Array<FilterOption>>) {
    state.appliedFilters = payload;
  },
  setBaseUrl(state: ArticleState, { payload }: PayloadAction<string>) {
    state.baseUrl = payload;
  },
  setContentType(state: ArticleState, { payload }: PayloadAction<string>) {
    state.contentType = payload;
  },
};
